<template>
  <bar-chart :chart-data="chartdata" :options="options" :plugins="plugins" />
</template>

<script>
import { BarChart } from '@/components/Charts'

const barThickness = 15
const colors = ['#FF9E50', '#B8E986', '#95E1DE', '#D48EC5', '#EBE969']

export default {
  name: 'DashboardBarChart',

  props: {
    data: {
      type: Array,
      default: () => ([])
      // Example:  [{ label: 'Work management', value: 30 }]
    },

    yTicks: {
      type: Array
      // Example: [{ value: 0, label: 'Label1' }, { value: 10, label: 'Label2' }]
      // Example (no labels): [{ value: 0 }, { value: 10 }]
    }
  },

  data() {
    return {
      plugins: [{
        id: 'legend-width',
        beforeInit: function (chart) {
          chart.legend.afterFit = function () {
            this.width = this.width + 70
          }
        }
      }]
    }
  },

  computed: {
    chartdata() {
      const values = this.data.map(p => p.value)
      const datasets = this.data.map((data, index) => ({
        label: data.label,
        data: this.datasetData(index, values),
        backgroundColor: colors[index % colors.length],
        barThickness: barThickness
      }))

      return {
        labels: values,
        datasets
      }
    },

    options() {
      const defaultTicks = {
        beginAtZero: true,
        stepSize: 1
      }

      let ticks = {}
      const yTicks = this.yTicks
      if (yTicks && yTicks.length > 0) {
        ticks = {
          ticks: {
            ...defaultTicks,
            autoSkip: false,
            suggestedMin: yTicks[0].value,
            suggestedMax: yTicks[yTicks.length - 1].value,
            callback: function (value, index, values) {
              return yTicks[index].label || value
            }
          },
          afterBuildTicks: function (scale) {
            scale.ticks = yTicks.map(tick => tick.value)
          },
          beforeUpdate: function (oScale) {
          }
        }
      }

      return {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: 'left',
          labels: {
            boxWidth: 8,
            padding: 20,
            fontSize: 14,
            usePointStyle: true
          }
        },

        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            position: 'right',
            gridLines: {
              borderDash: [8, 4]
            },
            ticks: {
              ...defaultTicks
            },
            ...ticks
          }]
        }
      }
    }
  },

  methods: {
    datasetData(index, data) {
      const array = new Array(data.length).fill(0)
      array[index] = data[index]
      return array
    }
  },

  components: {
    BarChart
  }
}
</script>
